import logo from "../logo.png"

export default function LoadingNoContainer() {
	return (
		<div className={"loading-container-no-height"}>
			<div>
				<img src={logo} alt={"refbin-logo"} />
			</div>
			<br />
			<div>Loading...</div>
		</div>
	)
}